import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { StoreModule } from '@ngrx/store';
import { EffectsModule } from '@ngrx/effects';

import { LinesRoutingModule } from './lines-routing.module';
import { LineDetailsComponent } from './components/line-details/line-details.component';
import { LinesListComponent } from './components/lines-list/lines-list.component';
import { SharedModule } from '../shared/shared.module';
import { LinesService } from './services/lines.service';
import { MsisdnProcedureService } from './services/msisdn-procedure.service';
import { DisplayProcedureMessageService } from './services/display-procedure-message.service';
import { CustomerProcedureService } from './services/customer-procedure.service';
import { ConstsHelper} from '../../helpers/consts.helper';
import { consumptionReducer } from './store/reducers/consumption.reducer';
import { lineReducer } from './store/reducers/line.reducer';
import { linesReducer } from './store/reducers/lines.reducer';
import { msisdnProceduresReducer } from './store/reducers/msisdn-producres.reducer';
import { customerProceduresReducer } from './store/reducers/customer-producres.reducer';
import { msisdnListReducer } from './store/reducers/msisdn-list.reducer';
import { offerDetailsReducer } from './store/reducers/offer-details.reducer';
import { selectedMsisdnReducer } from './store/reducers/selected-msisdn.reducer';
import { ConsumptionEffects } from './store/effects/consumption.effects';
import { LinesEffects } from './store/effects/lines.effects';
import { LineEffects } from './store/effects/line.effects';
import { MsisdnProceduresEffects } from './store/effects/msisdn-procedures.effects';
import { CustomerProceduresEffects } from './store/effects/customer-procedures.effects';
import { ConsumptionComponent } from './components/consumption/consumption.component';
import { ConsumptionDetailsComponent } from './components/consumption-details/consumption-details.component';
import { ModalLinesListComponent } from './components/modal-lines-list/modal-lines-list.component';
import { LineManagementComponent } from './components/line-management/line-management.component';
import { MsisdnListEffects } from './store/effects/msisdn-list.effects';
import { OfferDetailsEffects } from './store/effects/offer-details.effects';
import { LandLineListEffects } from '../landlines/store/effects/land-line-list.effects';

@NgModule({
  declarations: [LineDetailsComponent, LinesListComponent, ConsumptionComponent, ConsumptionDetailsComponent, ModalLinesListComponent, LineManagementComponent,],
    imports: [
        CommonModule,
        LinesRoutingModule,
        SharedModule,
        StoreModule.forFeature(ConstsHelper.REDUCER_CONSUMPTION, consumptionReducer),
        StoreModule.forFeature(ConstsHelper.REDUCER_MSISDN_LIST, msisdnListReducer),
        StoreModule.forFeature(ConstsHelper.REDUCER_SELECTED_MSISDN, selectedMsisdnReducer),
        StoreModule.forFeature(ConstsHelper.REDUCER_LINE, lineReducer),
        StoreModule.forFeature(ConstsHelper.REDUCER_LINES, linesReducer),
        StoreModule.forFeature(ConstsHelper.REDUCER_MSISDN_PROCEDURES, msisdnProceduresReducer),
        StoreModule.forFeature(ConstsHelper.REDUCER_CUSTOMER_PROCEDURES, customerProceduresReducer),
        StoreModule.forFeature(ConstsHelper.REDUCER_OFFER_DETAILS, offerDetailsReducer),
        EffectsModule.forFeature([
            ConsumptionEffects,
            LinesEffects,
            LineEffects,
            MsisdnProceduresEffects,
            CustomerProceduresEffects,
            MsisdnListEffects,
            OfferDetailsEffects,
            LandLineListEffects,
        ])
    ],
  providers: [
      LinesService,
      MsisdnProcedureService,
      CustomerProcedureService,
      DisplayProcedureMessageService
  ],
  exports: [ ModalLinesListComponent ]
})
export class LinesModule { }
